export const formatPrice = (
  amount: number | string | null | undefined,
  currency = "$",
) => {
  if (amount === null || amount === undefined || amount === "") {
    return "";
  }

  const numericAmount =
    typeof amount === "number" ? amount : Number.parseFloat(amount);

  if (Number.isNaN(numericAmount)) {
    return `${currency}${amount}`;
  }

  const roundedAmount =
    Math.round((numericAmount + Number.EPSILON) * 100) / 100;

  return Number.isInteger(roundedAmount)
    ? `${currency}${roundedAmount.toFixed(0)}`
    : `${currency}${roundedAmount.toFixed(2)}`;
};
